import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, MaskLineInView } from "@/components/motion/Reveal";
import { SERVICES } from "@/data/site";

const Services = () => {
  return (
    <div data-testid="services-page" className="bg-[#FAF9F6] pt-20">
      {/* Header */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-20 md:pt-32 pb-16 md:pb-24">
        <Reveal>
          <div className="overline text-[#8B7355] mb-8">What We Do</div>
        </Reveal>
        <h1 className="font-serif-display text-[#1A1A1A] leading-[0.98] text-[clamp(2.5rem,7vw,6.5rem)] tracking-[-0.02em] max-w-4xl">
          <MaskLineInView>Turnkey design,</MaskLineInView>
          <MaskLineInView delay={0.12} className="italic text-[#C5A880]">rendered flawless.</MaskLineInView>
        </h1>
        <Reveal delay={0.2}>
          <p className="mt-8 text-[#4A4A4A] text-base md:text-lg max-w-xl leading-relaxed">
            Three disciplines, one accountable studio. From first concept to the final styled reveal, every service is engineered for permanence and premium property value.
          </p>
        </Reveal>
      </section>

      {/* Service rows */}
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24 md:pb-40">
        <div className="border-t border-[#E5E5E5]">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.05}>
              <div
                data-testid={`service-card-${s.id}`}
                className="group grid md:grid-cols-12 gap-6 md:gap-10 py-14 md:py-20 border-b border-[#E5E5E5] transition-colors duration-500 hover:bg-[#F2EFEB]"
              >
                <div className="md:col-span-2 flex md:block items-baseline gap-4">
                  <span className="font-serif-display text-5xl md:text-7xl text-[#C5A880] leading-none group-hover:translate-x-2 transition-transform duration-500">
                    {s.id}
                  </span>
                </div>

                <div className="md:col-span-5">
                  <div className="overline text-[#8B7355] mb-4">{s.tagline}</div>
                  <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl leading-[1.05] text-[#1A1A1A]">
                    {s.title}
                  </h2>
                </div>

                <div className="md:col-span-5">
                  <p className="text-[#4A4A4A] leading-relaxed text-base md:text-lg">{s.description}</p>
                  <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-center gap-3 text-sm text-[#1A1A1A]">
                        <Check size={15} className="text-[#C5A880] shrink-0" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* CTA */}
        <Reveal>
          <div className="mt-20 md:mt-28 bg-[#1A1A1A] text-[#FAF9F6] px-8 md:px-16 py-16 md:py-24 flex flex-col md:flex-row md:items-end justify-between gap-10">
            <div>
              <div className="overline text-[#C5A880] mb-6">Begin the Process</div>
              <h2 className="font-serif-display text-3xl md:text-5xl leading-[1.05] max-w-lg">
                A single conversation is where every haven begins.
              </h2>
            </div>
            <Link
              to="/consultation"
              data-testid="services-cta"
              className="group inline-flex items-center gap-4 bg-[#C5A880] text-[#1A1A1A] px-8 py-4 hover:bg-[#FAF9F6] transition-colors duration-400 shrink-0"
            >
              <span className="text-sm tracking-wide">Request a Consultation</span>
              <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
};

export default Services;
